import { useEffect } from 'react';
import { Box, Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { errorMessages } from '~/constants/errorMessages.js';
import { safeWindowOpen } from '~/helpers/safeUrlOpen.ts';
import ModalAlert from '~/components/modals/ModalAlert/ModalAlert';
import { RootState } from '~/store/store.ts';
import { useAppDispatch } from '~/store/appDispatch.ts';
import { setPersonalDataApplicationsError } from '~/store/processing-personal/slices.ts';
import { styles } from './styles.ts';

export const ApplicationDocumentPreview = () => {
  const dispatch = useAppDispatch();
  const { fileURL, loading, error } = useSelector((state: RootState) => state.processingPersonal);

  const closeModalAlert = () => {
    if (error) {
      dispatch(setPersonalDataApplicationsError(''));
    }
  };

  useEffect(() => {
    if (!fileURL && !loading) {
      dispatch(setPersonalDataApplicationsError(errorMessages.SERVICE_UNAVAILABLE));
    }
  }, [dispatch, fileURL, loading]);

  const handleOpenInNewWindow = () => {
    if (!fileURL) {
      dispatch(setPersonalDataApplicationsError(errorMessages.SERVICE_UNAVAILABLE));
      return;
    }

    safeWindowOpen(fileURL);
  };

  return (
    <>
      <Box sx={styles.container}>
        <Box
          component="iframe"
          src={fileURL || undefined}
          title="Document Preview"
          sx={styles.iframe}
        />

        <Button
          variant="outlined"
          color="primary"
          type="button"
          sx={styles.openButton}
          onClick={handleOpenInNewWindow}
        >
          Відкрити в новому вікні
        </Button>
      </Box>

      {!!error && <ModalAlert isOpen={!!error} text={error} onClose={closeModalAlert} />}
    </>
  );
};
